import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text, TextField, Stack } from '@eds-web/react';
import { FormikProps } from 'formik';
import { PayoutFormValues } from '../../types/payout.types';

interface PayPalAccountProps {
    formik: FormikProps<PayoutFormValues>;
    disabled: boolean;
    handleChangeFormValues: (_: string, evt: any) => void;
}

export const PayPalAccount: React.FC<PayPalAccountProps> = ({
    formik,
    disabled,
    handleChangeFormValues
}) => {
    const { t } = useTranslation();

    return (
        <Stack gap={16}>
            <Text variant="headingSM">{t('epic.esport.label.paypal_account')}</Text>
            <TextField
                label={t('epic.esport.label.payoutInfo.offline.label.paypal')}
                name="accountEmail"
                value={formik.values.accountEmail}
                onChange={handleChangeFormValues}
                placeholder={t('epic.esport.label.payoutInfo.offline.label.paypal')}
                disabled={disabled}
                error={formik.touched.accountEmail && formik.errors.accountEmail}
                required
            />
        </Stack>
    );
};
